import React, {useEffect} from "react";
import RestRequest from "../../../tool/RestRequest";
import config from "../../../config";
import CookieService from "../../../service/CookieService";
import Common from "../../../tool/Common";

const CityList = ({models}) => {


    useEffect(() => {
        const btns = document.querySelectorAll('.header-select-city-list');
        btns.forEach(el => {
            el.addEventListener('click', handleClick);
        });
    }, []);

    let handleClick = (event) => {

        const _this = event.target;
        const cityId = _this.getAttribute('data-id');

        if (cityId.length <= 0) {
            return false;
        }

        CookieService.setCookieWithServer('cityId', cityId).then(data => {
            Common.redirect('/');
        });

    };

    return <div className="header-select-city-list" style={{maxHeight: `${models.length >= 10 ? models.length * 10 : 4 * 10}px`}}>
        {models.map((city, index) => {
            return <div key={index} data-id={city.code} className="header-select-city-list-item site-link">{city.name}</div>
        })}
    </div>
};
export default CityList;